import './component.scss'
import 'PackWerkNurikaeSite/pages/home/index/partials/general_modal/component'
import './images/line_modal_guide.webp'
import './images/green_right_arrow.svg'

import { Application, Controller } from 'stimulus'

const SP_WIDTH = 576

const app = Application.start()

app.register('prevent-leave-modal', class extends Controller {
  connect() {
    // 離脱防止モーダルを1度以上表示させないためのフラグ
    this.hasShownModal = false

    // SPの場合のみ離脱防止機能を初期化
    if (window.innerWidth <= SP_WIDTH) {
      this.initializePreventLeave()
    }
  }

  initializePreventLeave() {
    history.pushState(null, '', null)

    this.boundHandlePopState = this.handlePopState.bind(this)
    window.addEventListener('popstate', this.boundHandlePopState)
  }

  disconnect() {
    if (this.boundHandlePopState) {
      window.removeEventListener('popstate', this.boundHandlePopState)
    }
  }

  handlePopState(event) {
    if (this.hasShownModal) {
      history.back()
      return
    }

    // nurikaeドメインへのブラウザバックであれば離脱モーダルを出さない
    if (this.isNurikaeDomain()) {
      history.back()
      return
    }

    const targetDialog = document.querySelector('#prevent-leave-modal')
    if (targetDialog) {
      targetDialog.showModal()
      targetDialog.setAttribute('data-activate', 'true')
      this.hasShownModal = true
    }

    this.ga_datalayer_push()

    history.pushState(null, '', null)
  }

  isNurikaeDomain() {
    const currentDomain = window.location.hostname
    const referrer = document.referrer
    if (!referrer) return false

    const referrerDomain = new URL(referrer).hostname
    return currentDomain === referrerDomain
  }

  ga_datalayer_push() {
    window.dataLayer = window.dataLayer || [];
    const now = new Date();
    const currentTime = now.toISOString().slice(0, 19).replace('T', ' ');
    window.dataLayer.push({
      event: 'preventLeaveModal',
      preventLeaveModalCurrentTime: currentTime,
    });
  }
})
